/**
 * styles.ts
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

import { css } from '@emotion/react';

export const styles = {
  container: css({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    position: 'relative'
  }),

  wrapper: css({
    width: '100%',
    position: 'relative',
  }),

  input: css({
    margin: 0,
    border: 0,
    outline: 'none',
    appearance: 'none',
    fontFamily: 'inherit',
    background: 'transparent',

    width:        '100%',
    height:       '48px',
    padding:      '16px',
    fontSize:     '16px',
    lineHeight:   '24px',
    borderRadius: '5px',
    fontWeight:   '500',
    transition:   'box-shadow .2s',

    '[type="number"]': {
      appearance: 'textfield',
    },
  }),

  error: css({
    color: 'rgba(230, 103, 118, 1)',
    fontSize: '14px',
    fontWeight: '500'
  }),

  format: css({
    top: 0,
    right: 0,
    fontSize:   '14px',
    lineHeight: '24px',
    fontWeight: '500',
    padding: 12,
    color: 'rgb(132, 132, 148)',
    position: 'absolute',
  }),

  states: {
    default: css({
      boxShadow: '0 0 0 1px inset rgb(0, 0, 0)',
      color:     'rgb(0, 0, 0)',
      backgroundColor: 'rgb(255, 255, 255)',

      ':focus': {
        boxShadow: '0 0 0 2px inset rgb(0, 0, 0)',
      },

      ':disabled': {
        boxShadow: '0 0 0 1px inset rgb(204, 204, 204)',
        backgroundColor: 'rgb(216, 216, 224)'
      },

      '::placeholder': {
        color:     'rgb(182, 182, 200)',
      }
    }),

    error: css({

    })
  }
}